import { OffsetRangeMapping } from './offsetRange.js';
import { StringEdit } from './stringEdit.js';

/**
 * A block of text that was moved between two locations.
 *
 * `range` locates the block in `original` and in `modified` (offsets in the
 * respective full texts). `innerEdit` describes the changes inside the moved
 * block, with offsets local to the slice (i.e. `0` is the start of the slice).
 */
export class Move {
	constructor(
		readonly range: OffsetRangeMapping,
		readonly innerEdit: StringEdit,
	) { }

	toString(): string {
		return `Move ${this.range}` + (this.innerEdit.isEmpty ? '' : ` (${this.innerEdit})`);
	}
}
